/** Slot window helpers (matches backend/utils.py overnight semantics). */

export function timeToMinutes(t) {
  const [h, m] = String(t || '').split(':').map(Number);
  return (h * 60) + (m || 0);
}

/** True when closing time is on the next calendar day (incl. end === start as invalid zero-length — caller should reject that separately). */
export function isOvernight(startTime, endTime) {
  return timeToMinutes(endTime) <= timeToMinutes(startTime);
}

/** End of window in minutes from start of opening day; overnight adds 1440. */
export function effectiveEndMinutes(startTime, endTime) {
  const sm = timeToMinutes(startTime);
  const em = timeToMinutes(endTime);
  if (em <= sm) return em + 1440;
  return em;
}

/** Wall-clock minutes for iteration (may exceed 1440). */
export function wallMinutesToHHMM(mins) {
  const m = ((mins % 1440) + 1440) % 1440;
  const h = Math.floor(m / 60);
  const mm = m % 60;
  return `${String(h).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
}
